import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavLink } from 'react-router-dom';
import { FirestoreCollection } from 'react-firestore';
import FireflySubscription from '../misc/FireflySubscription';
import Firebase from 'firebase/app';
import Error from '../misc/Error';

class AddToListButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      isOpen: false,
      menuPosition: null,
      profile: this.props.profile,
      dataType: this.props.dataType,
      journalistIndex: [],
      podcastIndex: [],
      broadcasterIndex: [],
      influencerIndex: [],
      emailIndex: [],
    };
    this._isMounted = false;
    this.dropdownRef = React.createRef();
    this.buttonRef = React.createRef();
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    this._isMounted = true;
    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('scroll', this.handleWindowChange, true);
    window.addEventListener('resize', this.handleWindowChange);
  }

  componentWillUnmount() {
     this._isMounted = false;
     document.removeEventListener('mousedown', this.handleClickOutside);
     window.removeEventListener('scroll', this.handleWindowChange, true);
     window.removeEventListener('resize', this.handleWindowChange);
  }

  handleClickOutside = (event) => {
    const clickedButton = this.buttonRef.current && this.buttonRef.current.contains(event.target);
    const clickedMenu = this.menuRef.current && this.menuRef.current.contains(event.target);
    if (!clickedButton && !clickedMenu) {
      this.setState({ isOpen: false });
    }
  };

  updateMenuPosition = () => {
    if (!this.buttonRef.current) return;
    const rect = this.buttonRef.current.getBoundingClientRect();
    const width = 224;
    const left = Math.max(12, rect.right - width);
    const top = rect.bottom + 6;
    this.setState({ menuPosition: { top, left, width } });
  };

  handleWindowChange = () => {
    if (this.state.isOpen) {
      this.updateMenuPosition();
    }
  };

  toggleDropdown = () => {
    this.setState(
      prevState => ({ isOpen: !prevState.isOpen }),
      () => {
        if (this.state.isOpen) {
          this.updateMenuPosition();
        }
      }
    );
  };

  formatUpdatedAt = (value) => {
    if (!value) return '';
    const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  async addJournalistToList(key, profile, plan) {
    try {
      console.log("adding journalist");

      let objectID = profile.objectID;
      console.log("addJournalistToList", { listId: key, objectID });
      var docRef = Firebase.firestore().collection("lists").doc(key);

      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          journalistIndex: doc.data().journalistIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        //if email already exists in the index, return alert
        if (objectID && this.state.journalistIndex.includes(objectID)) {
          return alert("duplicate record");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          profile["counter"] = snap.size + 1;
          profile.addedOn = Firebase.firestore.Timestamp.now();
          profile.dataType = "journalist";

          if (profile.secondary_email && profile.email === "") {
            profile.email = profile.secondary_email;
          }

          docRef.collection("entries")
            .add(profile)
            .then( () => {
              let journalistIndex= this.state.journalistIndex;
              journalistIndex.push(objectID);
              docRef.update({
                updatedOn: Firebase.firestore.Timestamp.now(),
                journalistIndex
              });
            })
            .catch( error => {
              alert(`Whoops, couldn't add the record: ${error.message}`)
            });
          this.setState({ saved: true });
          setTimeout(() => {
            this.setState({ saved: false });
          }, 1000);
        }
        else
          return alert("You reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addJournalistToList failed", error);
      alert(`Whoops, couldn't add the record: ${error.message}`)
    }
  };

  async addPodcastToList(key, profile, plan) {
    try {
      console.log("adding Podcast");

      let objectID = profile.objectID;
      console.log("addPodcastToList", { listId: key, objectID });
      var docRef = Firebase.firestore().collection("lists").doc(key);

      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          podcastIndex: doc.data().podcastIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        //if email already exists in the index, return alert
        if (objectID && this.state.podcastIndex.includes(objectID)) {
          return alert("duplicate record");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          profile["counter"] = snap.size + 1;
          profile.addedOn = Firebase.firestore.Timestamp.now();
          profile.dataType = "podcast";
          profile.name = profile.title;

          docRef.collection("entries")
            .add(profile)
            .then( () => {
              let podcastIndex= this.state.podcastIndex;
              podcastIndex.push(objectID);
              docRef.update({
                updatedOn: Firebase.firestore.Timestamp.now(),
                podcastIndex
              });
            })
            .catch( error => {
              alert(`Whoops, couldn't add the record: ${error.message}`)
            });
          this.setState({ saved: true });
          setTimeout(() => {
            this.setState({ saved: false });
          }, 1000);
        }
        else
          return alert("You reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addPodcastToList failed", error);
      alert(`Whoops, couldn't add the record: ${error.message}`)
    }
  };

  async addBroadcastToList(key, profile, plan) {
    try {
      console.log("adding Broadcaster");

      let objectID = profile.objectID;
      console.log("addBroadcastToList", { listId: key, objectID });
      var docRef = Firebase.firestore().collection("lists").doc(key);

      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          broadcasterIndex: doc.data().broadcasterIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        //if email already exists in the index, return alert
        if (objectID && this.state.broadcasterIndex.includes(objectID)) {
          return alert("duplicate record");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          profile["counter"] = snap.size + 1;
          profile.addedOn = Firebase.firestore.Timestamp.now();
          profile.dataType = "broadcaster";
          if (profile.name !== undefined) {
            profile.name = profile.outlet;
          };

          docRef.collection("entries")
            .add(profile)
            .then( () => {
              let broadcasterIndex= this.state.broadcasterIndex;
              broadcasterIndex.push(objectID);
              docRef.update({
                updatedOn: Firebase.firestore.Timestamp.now(),
                broadcasterIndex
              });
            })
            .catch( error => {
              alert(`Whoops, couldn't add the record: ${error.message}`)
            });
          this.setState({ saved: true });
          setTimeout(() => {
            this.setState({ saved: false });
          }, 1000);
        }
        else
          return alert("You reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addBroadcastToList failed", error);
      alert(`Whoops, couldn't add the record: ${error.message}`)
    }
  };

  async addInfluencerToList(key, profile, plan) {
    console.log("adding Influencer");

    let objectID = profile.objectID;
    var docRef = Firebase.firestore().collection("lists").doc(key);

    await docRef.get().then(doc => {
      //fetch email Index and set state as such
      this.setState({
        influencerIndex: doc.data().influencerIndex || [],
        isOpen: false,
      })
    })
    await docRef.collection("entries").get().then(snap => {
      if (snap.size > 12000) {
        return alert("You've reached limit. Please contact support!");
      }
      //if email already exists in the index, return alert
      if (objectID && this.state.influencerIndex.includes(objectID)) {
        return alert("duplicate record");
      }
      if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
        profile["counter"] = snap.size + 1;
        profile.addedOn = Firebase.firestore.Timestamp.now();
        profile.dataType = "influencer";

        docRef.collection("entries")
          .add(profile)
          .then( () => {
            let influencerIndex= this.state.influencerIndex;
            influencerIndex.push(objectID);
            docRef.update({
              updatedOn: Firebase.firestore.Timestamp.now(),
              influencerIndex
            });
          })
          .catch( error => {
            alert(`Whoops, couldn't add the record: ${error.message}`)
          });
        this.setState({ saved: true });
        setTimeout(() => {
          this.setState({ saved: false });
        }, 1000);
      }
      else
        return alert("You reached your limit of 200 entries!");
    });
  };

  async addToList(key, profile, plan) {
    console.log("legacy function");
  };

  render() {
    const { profile, dataType, saved, isOpen, menuPosition } = this.state;

    return (
      <FireflySubscription>
        { ({isLoading, error, auth, subscription}) => {
          if (isLoading) {
            return <span />
          }
          if (error) {
            return <Error error={error} />
          }
          if (!auth) {
            return <div>
              <p>Log in to see your account</p>
            </div>
          }
          return  <FirestoreCollection
            path={`lists`}
            sort="createdOn:desc"
            filter={['createdBy', '==', auth.uid]}
          >
            { ({error, isLoading, data}) => {
              if (error) {
                return <Error error={error} />
              }
              if (isLoading) {
                return <span />
              }
                const renderMenu = () => (
                  ReactDOM.createPortal(
                    <div
                      ref={this.menuRef}
                      className="bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden"
                      style={{
                        position: 'fixed',
                        top: menuPosition ? menuPosition.top : 0,
                        left: menuPosition ? menuPosition.left : 0,
                        width: menuPosition ? menuPosition.width : 224,
                        zIndex: 9999,
                      }}
                    >
                      <div className="max-h-64 overflow-y-auto divide-y divide-gray-100">
                        {data.map((list, index) => (
                          ((subscription.plan === 2 || subscription === 20) && list.csvUpload) ? (
                            <NavLink
                              key={index}
                              to="/pricing"
                              className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                            >
                              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                              <span className="truncate flex-1">{list.name}</span>
                              <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                              </svg>
                            </NavLink>
                          ) : (
                            <button
                              key={index}
                              onClick={() => {
                                dataType === "journalist" ?
                                this.addJournalistToList(list.id, profile, subscription.plan) : dataType === "podcast" ?
                                this.addPodcastToList(list.id, profile, subscription.plan) : dataType === "broadcaster" ?
                                this.addBroadcastToList(list.id, profile, subscription.plan) : dataType === "influencer" ?
                                this.addInfluencerToList(list.id, profile, subscription.plan) : this.addToList(list.id, profile, subscription.plan);
                              }}
                              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 text-left"
                            >
                              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                              <span className="flex-1 min-w-0">
                                <span className="block truncate">{list.name || 'Untitled list'}</span>
                                {list.updatedOn ? (
                                  <span className="block text-xs text-gray-400 truncate">
                                    Updated {this.formatUpdatedAt(list.updatedOn)}
                                  </span>
                                ) : null}
                              </span>
                            </button>
                          )
                        ))}
                      </div>
                      <div className="border-t border-gray-100 p-2">
                        {(subscription.plan === 1 || subscription.plan === 10) ? (
                          <NavLink
                            to="/pricing"
                            className="flex items-center gap-2 w-full px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-150"
                          >
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                            </svg>
                            New list
                            <svg className="w-4 h-4 ml-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                          </NavLink>
                        ) : (
                          <NavLink
                            to="/lists/new"
                            className="flex items-center gap-2 w-full px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-150"
                          >
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                            </svg>
                            New list
                          </NavLink>
                        )}
                      </div>
                    </div>,
                    document.body
                  )
                );

                if (!isLoading && data.length === 0) {
                return (
                  <div ref={this.dropdownRef} className="relative">
                    <button
                        ref={this.buttonRef}
                      onClick={this.toggleDropdown}
                      className="inline-flex items-center gap-1.5 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg shadow-sm hover:shadow transition-all duration-150"
                    >
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      <span>Add to List</span>
                      <svg className={`w-3.5 h-3.5 transition-transform duration-150 ${isOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {isOpen && renderMenu()}
                  </div>
                )
              }
              return (
                <div ref={this.dropdownRef} className="relative">
                  {saved ? (
                    <span className="inline-flex items-center gap-1.5 px-3 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg">
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      Saved!
                    </span>
                  ) : (
                    <>
                      <button
                        ref={this.buttonRef}
                        onClick={this.toggleDropdown}
                        className="inline-flex items-center gap-1.5 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg shadow-sm hover:shadow transition-all duration-150"
                      >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                        <span>Add to List</span>
                        <svg className={`w-3.5 h-3.5 transition-transform duration-150 ${isOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {isOpen && renderMenu()}
                    </>
                  )}
                </div>
              )
            }}
          </FirestoreCollection>
        }}
      </FireflySubscription>
    )
  }
}
export default AddToListButton;
